module.exports = __webpack_public_path__ + "img/icons_UI_icon_check.1e6451c4.svg";